import styled from "@emotion/styled";

const Radio = styled.input`
  width: 19px;
  height: 19px;
  border: 2px solid #f0f0f0;
  border-radius: 100%;

  &:checked {
    background: #0076ff;
    border: none;
  }
`;

Radio.defaultProps = { type: "radio", role: "radio" };

export default Radio;
